import request from '../utils/request.js'

/**
 * 购物车商品列表
 * **/
export function getOrderList(data) {
  return request({
    url: '/rest/cart/order/list' + data,
    method: 'get'
  })
}


/**
 * 取消订单
 * **/
export function orderCancel(code) {
  return request({
    url: '/rest/cart/order/cancel/' + code,
    method: 'post'
  })
}


// WEBPACK FOOTER //
// ./src/api/order-status-cart.js